import { render, staticRenderFns } from "./monthstockdetail.vue?vue&type=template&id=4a52e7e7&scoped=true&"
import script from "./monthstockdetail.vue?vue&type=script&lang=js&"
export * from "./monthstockdetail.vue?vue&type=script&lang=js&"
import style0 from "./monthstockdetail.vue?vue&type=style&index=0&id=4a52e7e7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a52e7e7",
  null
  
)

export default component.exports